import SiteHeader from './components/SiteHeader';
import HeroSection from './components/HeroSection';
import PackagePicker from './components/PackagePicker';
import FeatureFlow from './components/FeatureFlow';
import InstallGuide from './components/InstallGuide';
import AudienceSection from './components/AudienceSection';
import FaqSection from './components/FaqSection';
import DownloadBanner from './components/DownloadBanner';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <PackagePicker />
        <FeatureFlow />
        <InstallGuide />
        <AudienceSection />
        <FaqSection />
        <DownloadBanner />
      </main>
      <SiteFooter />
    </div>
  );
}